module.exports = __webpack_public_path__ + "img/footer-logo4.641821dd.png";